/**
 * MCP Server Node Component - Orange colored circular node for MCP Servers
 * Uses exported Figma asset for the icon
 */

import React from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import mcpIcon from '../../assets/mcp_server.png';
import './graphNodes.css';

interface MCPNodeData {
  label: string;
  description?: string;
  vulnerabilityCount?: number;
}

const MCPNode: React.FC<NodeProps<MCPNodeData>> = ({ data }) => {
  return (
    <div className="workflow-node workflow-node--mcp">
      {/* LEFT: target="left", source="left-source" */}
      <Handle type="target" position={Position.Left} id="left" className="workflow-node__handle" />
      <Handle type="source" position={Position.Left} id="left-source" className="workflow-node__handle" />

      {/* RIGHT: source="right", target="right-target" */}
      <Handle type="source" position={Position.Right} id="right" className="workflow-node__handle" />
      <Handle type="target" position={Position.Right} id="right-target" className="workflow-node__handle" />

      {/* TOP: target="top", source="top-source" */}
      <Handle type="target" position={Position.Top} id="top" className="workflow-node__handle" />
      <Handle type="source" position={Position.Top} id="top-source" className="workflow-node__handle" />

      {/* BOTTOM: source="bottom", target="bottom-target" */}
      <Handle type="source" position={Position.Bottom} id="bottom" className="workflow-node__handle" />
      <Handle type="target" position={Position.Bottom} id="bottom-target" className="workflow-node__handle" />
      
      <div className="workflow-node__container">
        <img 
          src={mcpIcon} 
          alt="MCP Server" 
          className="workflow-node__asset-icon"
        />
      </div>
      
      <div className="workflow-node__label">{data.label}</div>
    </div>
  );
};

export default MCPNode;
